import { render, staticRenderFns } from "./ProgressChannel.vue?vue&type=template&id=63344516&scoped=true&"
import script from "./ProgressChannel.vue?vue&type=script&lang=js&"
export * from "./ProgressChannel.vue?vue&type=script&lang=js&"
import style0 from "./ProgressChannel.vue?vue&type=style&index=0&id=63344516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63344516",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63344516')) {
      api.createRecord('63344516', component.options)
    } else {
      api.reload('63344516', component.options)
    }
    module.hot.accept("./ProgressChannel.vue?vue&type=template&id=63344516&scoped=true&", function () {
      api.rerender('63344516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProgressChannel.vue"
export default component.exports